import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { toast } from 'react-toastify';
import ImageModalEquip from '../Modal/ImageModalProd';
import { useSearch } from '../../SearchContext';
import { decryptToken } from '../utils/getToken';


const NewArrivalModal = ({ isOpen, setIsOpen, data, setData, sliderFetch }) => {
    const url = process.env.REACT_APP_LINK;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [productOptions, setProductOptions] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [showBackgroundModal, setShowBackgroundModal] = useState(false);
    const [images, setImages] = useState([]);
    const { globalSearch } = useSearch();
    const token = decryptToken("accessToken") || ""

    const fetchImages = async () => {
        try {
            const res = await fetch(`${url}/api/images`);
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await fetch(`${url}/grouped-product/search-all-products/${isLoggedIn.main_id}`);
            const res = await response.json();

            const options = res.map((product) => ({
                value: product.product_id,     // or product.id
                label: product.title,
                ...product              // 👈 include all product fields here
            }));

            setProductOptions(options);
        } catch (error) {
            console.log(error);
        }
    };

    console.log(data)
    useEffect(() => {
        fetchProducts();
    }, []);

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleProductSelect = (selectedOption) => {
        const fullProduct = productOptions.find(p => p.value === selectedOption.value);
        setData({ ...data, product: fullProduct });
    };

    const handleImageSelect = (field, img) => {
        setData((prev) => ({ ...prev, [field]: `${url}${img.url}` }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...data,
            user_id: isLoggedIn.main_id,
            product: data.product,
            user_name: isLoggedIn.full_name,
        };

        const response = await fetch(`${url}/newarrival${data.id ? `/${data.id}` : ""}`, {
            method: data.id ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
        });

        const res = await response.json();
        if (response.ok) {
            toast.success("Section saved successfully");
            sliderFetch();
            setIsOpen(false);
        } else {
            toast.error("Failed to save section");
        }
    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">New Section</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>

                    {/* Section Title */}
                    <div className="oms-form-group">
                        <label htmlFor="category_name" className="oms-form-label">Section Title</label>
                        <input
                            type="text"
                            id="category_name"
                            name="category_name"
                            value={data.category_name}
                            onChange={handleChange}
                            placeholder="e.g. Trending Products, Best Sellers"
                        />
                    </div>

                    {/* Description */}
                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">Section Description</label>
                        <input
                            type="text"
                            id="description"
                            name="description"
                            value={data.description}
                            onChange={handleChange}
                            placeholder="Write a brief description of this section"
                        />
                    </div>

                    {/* Product Selection */}
                    <div className="oms-form-group">
                        <label htmlFor="product" className="oms-form-label">Linked Products</label>
                        <Select
                            options={productOptions}
                            value={data.product}
                            onChange={(selectedOptions) => setData({ ...data, product: selectedOptions })}
                            placeholder="Search and select products to display"
                            isClearable
                            isMulti
                        />
                    </div>

                    {/* Actions */}
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>

    );
};


export default NewArrivalModal;
